import { Component } from '@angular/core';

@Component({
  selector: 'sobrenos',
  templateUrl: 'sobrenos.html'
})
export class SobreNosPage {
	constructor() {}
}


// WEBPACK FOOTER //
// ./src/pages/sobrenos/sobrenos.ts